import React from 'react';
import { useClippableTrackAsset } from '../../components/ClippableTrackAsset';
import TrackAsset from '../../components/TrackAsset';
import { VideoAssetProps } from '../../components/VideoAsset';
import VideoAssetThumbnail from '../../components/VideoAsset/VideoAssetThumbnail';
import useVideoClipAsset, {
  UseVideoClipAssetProps,
} from '../VideoClipAsset/useVideoClipAsset';
import FramingTimeline from './FramingTimeline';

type BaseAssetProps = UseVideoClipAssetProps &
  Pick<VideoAssetProps, 'aspectRatio' | 'posterClassName'>;

export type AutoframedVideoAssetProps = BaseAssetProps & {
  className?: string;
};

function AutoframedVideoAsset(props: AutoframedVideoAssetProps) {
  const { aspectRatio, posterClassName, pxPerSec, id } = props;

  const { position, posterSrc, scaling, ...videoAssetData } = useVideoClipAsset(
    props,
  );

  const { trackAssetProps } = useClippableTrackAsset({
    pxPerSec,
    id,
    position: { x: position, y: 0 },
    ...props,
    ...videoAssetData,
  });

  return (
    <TrackAsset eyebrow={<FramingTimeline />} {...trackAssetProps}>
      <VideoAssetThumbnail
        aspectRatio={aspectRatio}
        className={posterClassName}
        scaling={scaling}
        src={posterSrc}
      />
    </TrackAsset>
  );
}

export default AutoframedVideoAsset;
